var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSignOut = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  "aria-hidden": "true",
  focusable: "false",
  viewBox: "0 0 24 24",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "svg-sign-out__a",
  d: "M10.483.087a.5.5 0 0 1 .09.992l-.09.008H2.262a.675.675 0 0 0-.667.575l-.008.1v14.094c0 .338.25.619.575.667l.1.008h8.221a.5.5 0 0 1 .09.992l-.09.008H2.262A1.675 1.675 0 0 1 .593 16l-.006-.145V1.762c0-.876.673-1.595 1.53-1.669l.145-.006h8.221ZM14.291 3.7l.07.058 4.698 4.698.013.014a.503.503 0 0 1 .032.038l-.045-.052a.502.502 0 0 1 .146.354v.01a.503.503 0 0 1-.005.064l.005-.074a.502.502 0 0 1-.088.284l-.013.018a.503.503 0 0 1-.03.036l-.015.015-4.698 4.699a.5.5 0 0 1-.765-.638l.057-.07 3.844-3.845H6.96a.5.5 0 0 1-.09-.991l.09-.008h10.537l-3.844-3.845a.5.5 0 0 1-.057-.637l.057-.07a.5.5 0 0 1 .638-.058Z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(2 3)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "svg-sign-out__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#svg-sign-out__a"
})), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#svg-sign-out__a",
  fill: "#FFF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#svg-sign-out__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M-2-3h24v24H-2z"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSignOut);
export default ForwardRef;